var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link}},[_c('span',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.srcImage},on:{"mouseover":function($event){_vm.srcImage = _vm.hoverImage},"mouseout":function($event){_vm.srcImage = _vm.originalImage}}})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f8bcef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Reveal/ImageHighlight.vue
// module id = af4l
// module chunks = 1